// extracted by mini-css-extract-plugin
module.exports = {"create-license-plate-form":"create-license-plate-modal_create-license-plate-form__PUrhL","button-group":"create-license-plate-modal_button-group__3ZSPr"};